var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_127","data-name":"Path 127","d":"M-322.76-51.063l-5.351-1.9a.242.242,0,0,1-.084-.406l16.872-15.613a.242.242,0,0,1,.395.253l-3.418,10.51a.242.242,0,0,0,.149.3l5.638,2.015a.242.242,0,0,1,.084.4l-17.448,16.285a.242.242,0,0,1-.4-.252l1.685-5.191a.241.241,0,0,1,.066-.1l10.293-9.517a.242.242,0,0,0-.083-.406l-3.694-1.308a.242.242,0,0,1-.15-.3l.666-2.105a.242.242,0,0,0-.4-.251l-4.4,4.064a.242.242,0,0,0,.083.406l3.509,1.251a.242.242,0,0,1,.083.406l-4.189,3.866a.242.242,0,0,1-.393-.256l.628-1.851A.242.242,0,0,0-322.76-51.063Z","transform":"translate(328.272 69.044)","fill":"#231f20"}));
}

Lightning.defaultProps = {"width":"19.874","height":"29.902","viewBox":"0 0 19.874 29.902"};

module.exports = Lightning;

Lightning.default = Lightning;
